import { required } from 'AppReact/schema';

export default {
  sortingField: required('string'),
  label: required('string'),
}